import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OrderCard from "./OrderCard";
import shopApi from "../../api/shop";


const OrderNotifications = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState("Pending");

  const locale = useSelector((state) => state.locale);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        shopApi.getUsersOrders(statusFilter, locale).then((response) => {
          setOrders(response);
        });
      } catch (err) {
        setError("Une erreur s'est produite lors du chargement des commandes.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [statusFilter, locale]);

  const handleMarkAsCompleted = async (orderId) => {
    try {
      shopApi.updateOrdersStatus(orderId);
      setOrders((prevOrders) =>
        prevOrders.filter((order) => order._id !== orderId)
      );
    
    } catch (err) {
      alert("Une erreur s'est produite lors de la modification de la commande.");
    }
  };

  const handleFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  if (loading)
    return (
      <div className=" justify-content-center align-items-center" style={{ height: "60vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );

  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container mt-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>
          Notifications de Commandes
        </h1>
        <div className="d-flex align-items-center">
          <label htmlFor="statusFilter" className="me-2">
            Filtrer par statut :
          </label>
          <select
            id="statusFilter"
            value={statusFilter}
            onChange={handleFilterChange}
            className="form-select form-select-sm"
            style={{ width: "150px" }}
          >
            <option value="Pending">En attente</option>
            <option value="Completed">Terminées</option>
            <option value="All">Toutes</option>
          </select>
        </div>
      </div>

      {/* Liste des commandes */}
      {orders?.length === 0 ? (
        <div className="alert alert-info">Aucune commande trouvée.</div>
      ) : (
        <div className="col">
          {orders?.map((order) => (
            <div key={order._id} >
              <OrderCard order={order} onComplete={handleMarkAsCompleted} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderNotifications;
